<template lang="pug">
.empty
  .content
    img(src='https://m.hellobike.com/resource/AppPlatformH5/card-for-app/dXRL1f9LysVmOiO7V-lBs.png')
    span.title-big 暂无特惠信息
    span.title-small {{text}}
    .footer(@click='clicks') {{btntext}}

</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getPageBPort } from './utils';

export default {
  props: {
    text: {
      type: String,
      default: '去下载哈啰APP，查看更多优惠信息',
    },
    btntext: {
      type: String,
      default: '下载哈啰',
    },
  },
  mounted() {
    UBT.pageView({
      pageId: 'platform_none',
      categoryId: 'platform',
      businessInfo: {
        port: getPageBPort(),
      },
    });
  },
  methods: {
    clicks() {
      this.$emit('click');
    },
  },

};
</script>
<style lang="less" scoped>
.empty {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 99999;

  .content {
    display: flex;
    flex-direction: column;
    margin-top: 1.55rem;
    text-align: center;

    img {
      display: block;
      margin: 0 auto;
      width: 1.98rem;
      height: 1.55rem;
    }

    .title-big {
      margin-top: 0.11rem;
      font-size: 0.16rem;
      font-weight: 400;
      color: #242729;
      line-height: 0.22rem;
    }

    .title-small {
      margin-top: 0.08rem;
      font-size: 0.12rem;
      font-weight: 400;
      color: #879099;
      line-height: 0.17rem;
      white-space: nowrap;
    }

    .footer {
      margin: 0.2rem auto;
      height: 0.34rem;
      padding: 0 0.19rem 0 0.2rem;
      box-sizing: border-box;
      line-height: 0.34rem;
      border-radius: 0.17rem;
      border: 0.01rem solid #08f;
      font-size: 0.16rem;
      font-weight: 400;
      color: #0081f1;
    }
  }
}
</style>
